// Source: https://github.com/muan/unicode-emoji-json

// Source: https://github.com/mathiasbynens/emoji-regex
const emojiRegex = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFE])|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC3B\u200D\u2744|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDF])\u200D[\u2640\u2642])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;

const emojis = {
  "1st_place_medal": "🥇",
  "2nd_place_medal": "🥈",
  "3rd_place_medal": "🥉",
  "a_button": "🅰️",
  "ab_button": "🆎",
  "abacus": "🧮",
  "adhesive_bandage": "🩹",
  "admission_tickets": "🎟️",
  "aerial_tramway": "🚡",
  "airplane": "✈️",
  "airplane_arrival": "🛬",
  "airplane_departure": "🛫",
  "alarm_clock": "⏰",
  "alembic": "⚗️",
  "alien": "👽",
  "alien_monster": "👾",
  "ambulance": "🚑",
  "american_football": "🏈",
  "amphora": "🏺",
  "anchor": "⚓",
  "anger_symbol": "💢",
  "angry_face": "😠",
  "angry_face_with_horns": "👿",
  "anguished_face": "😧",
  "ant": "🐜",
  "antenna_bars": "📶",
  "anxious_face_with_sweat": "😰",
  "aquarius": "♒",
  "aries": "♈",
  "articulated_lorry": "🚛",
  "artist": "🧑‍🎨",
  "artist_palette": "🎨",
  "astonished_face": "😲",
  "astronaut": "🧑‍🚀",
  "atm_sign": "🏧",
  "atom_symbol": "⚛️",
  "auto_rickshaw": "🛺",
  "automobile": "🚗",
  "avocado": "🥑",
  "axe": "🪓",
  "b_button": "🅱️",
  "baby": "👶",
  "baby_angel": "👼",
  "baby_bottle": "🍼",
  "baby_chick": "🐤",
  "baby_symbol": "🚼",
  "back_arrow": "🔙",
  "backhand_index_pointing_down": "👇",
  "backhand_index_pointing_left": "👈",
  "backhand_index_pointing_right": "👉",
  "backhand_index_pointing_up": "👆",
  "backpack": "🎒",
  "bacon": "🥓",
  "badger": "🦡",
  "badminton": "🏸",
  "bagel": "🥯",
  "baggage_claim": "🛄",
  "baguette_bread": "🥖",
  "balance_scale": "⚖️",
  "ballet_shoes": "🩰",
  "balloon": "🎈",
  "ballot_box_with_ballot": "🗳️",
  "banana": "🍌",
  "banjo": "🪕",
  "bank": "🏦",
  "bar_chart": "📊",
  "barber_pole": "💈",
  "baseball": "⚾",
  "basket": "🧺",
  "basketball": "🏀",
  "bat": "🦇",
  "bathtub": "🛁",
  "battery": "🔋",
  "beach_with_umbrella": "🏖️",
  "beaming_face_with_smiling_eyes": "😁",
  "bear": "🐻",
  "beating_heart": "💓",
  "bed": "🛏️",
  "beer_mug": "🍺",
  "bell": "🔔",
  "bell_with_slash": "🔕",
  "bellhop_bell": "🛎️",
  "bento_box": "🍱",
  "beverage_box": "🧃",
  "bicycle": "🚲",
  "bikini": "👙",
  "billed_cap": "🧢",
  "biohazard": "☣️",
  "bird": "🐦",
  "birthday_cake": "🎂",
  "black_circle": "⚫",
  "black_flag": "🏴",
  "black_heart": "🖤",
  "black_large_square": "⬛",
  "black_medium_small_square": "◾",
  "black_medium_square": "◼️",
  "black_nib": "✒️",
  "black_small_square": "▪️",
  "black_square_button": "🔲",
  "blossom": "🌼",
  "blowfish": "🐡",
  "blue_book": "📘",
  "blue_circle": "🔵",
  "blue_heart": "💙",
  "blue_square": "🟦",
  "boar": "🐗",
  "bomb": "💣",
  "bone": "🦴",
  "bookmark": "🔖",
  "bookmark_tabs": "📑",
  "books": "📚",
  "bottle_with_popping_cork": "🍾",
  "bouquet": "💐",
  "bow_and_arrow": "🏹",
  "bowl_with_spoon": "🥣",
  "bowling": "🎳",
  "boxing_glove": "🥊",
  "boy": "👦",
  "brain": "🧠",
  "bread": "🍞",
  "breast_feeding": "🤱",
  "brick": "🧱",
  "bride_with_veil": "👰",
  "bridge_at_night": "🌉",
  "briefcase": "💼",
  "briefs": "🩲",
  "bright_button": "🔆",
  "broccoli": "🥦",
  "broken_heart": "💔",
  "broom": "🧹",
  "brown_circle": "🟤",
  "brown_heart": "🤎",
  "brown_square": "🟫",
  "bug": "🐛",
  "building_construction": "🏗️",
  "bullet_train": "🚅",
  "burrito": "🌯",
  "bus": "🚌",
  "bus_stop": "🚏",
  "bust_in_silhouette": "👤",
  "busts_in_silhouette": "👥",
  "butter": "🧈",
  "butterfly": "🦋",
  "cactus": "🌵",
  "calendar": "📅",
  "call_me_hand": "🤙",
  "camel": "🐪",
  "camera": "📷",
  "camera_with_flash": "📸",
  "camping": "🏕️",
  "cancer": "♋",
  "candle": "🕯️",
  "candy": "🍬",
  "canned_food": "🥫",
  "canoe": "🛶",
  "capricorn": "♑",
  "card_file_box": "🗃️",
  "card_index": "📇",
  "card_index_dividers": "🗂️",
  "carousel_horse": "🎠",
  "carp_streamer": "🎏",
  "carrot": "🥕",
  "castle": "🏰",
  "cat": "🐈",
  "cat_face": "🐱",
  "cat_with_tears_of_joy": "😹",
  "cat_with_wry_smile": "😼",
  "chains": "⛓️",
  "chair": "🪑",
  "chart_decreasing": "📉",
  "chart_increasing": "📈",
  "chart_increasing_with_yen": "💹",
  "check_box_with_check": "☑️",
  "check_mark": "✔️",
  "check_mark_button": "✅",
  "cheese_wedge": "🧀",
  "chequered_flag": "🏁",
  "cherries": "🍒",
  "cherry_blossom": "🌸",
  "chess_pawn": "♟️",
  "chestnut": "🌰",
  "chicken": "🐔",
  "child": "🧒",
  "children_crossing": "🚸",
  "chipmunk": "🐿️",
  "chocolate_bar": "🍫",
  "chopsticks": "🥢",
  "christmas_tree": "🎄",
  "church": "⛪",
  "cigarette": "🚬",
  "cinema": "🎦",
  "circled_m": "Ⓜ️",
  "circus_tent": "🎪",
  "cityscape": "🏙️",
  "cityscape_at_dusk": "🌆",
  "cl_button": "🆑",
  "clamp": "🗜️",
  "clapper_board": "🎬",
  "clapping_hands": "👏",
  "classical_building": "🏛️",
  "clinking_beer_mugs": "🍻",
  "clinking_glasses": "🥂",
  "clipboard": "📋",
  "clockwise_vertical_arrows": "🔃",
  "closed_book": "📕",
  "closed_mailbox_with_lowered_flag": "📪",
  "closed_mailbox_with_raised_flag": "📫",
  "closed_umbrella": "🌂",
  "cloud": "☁️",
  "cloud_with_lightning": "🌩️",
  "cloud_with_lightning_and_rain": "⛈️",
  "cloud_with_rain": "🌧️",
  "cloud_with_snow": "🌨️",
  "clown_face": "🤡",
  "club_suit": "♣️",
  "clutch_bag": "👝",
  "coat": "🧥",
  "cocktail_glass": "🍸",
  "coconut": "🥥",
  "coffin": "⚰️",
  "cold_face": "🥶",
  "collision": "💥",
  "comet": "☄️",
  "compass": "🧭",
  "computer_disk": "💽",
  "computer_mouse": "🖱️",
  "confetti_ball": "🎊",
  "confounded_face": "😖",
  "confused_face": "😕",
  "construction": "🚧",
  "construction_worker": "👷",
  "control_knobs": "🎛️",
  "convenience_store": "🏪",
  "cook": "🧑‍🍳",
  "cooked_rice": "🍚",
  "cookie": "🍪",
  "cooking": "🍳",
  "cool_button": "🆒",
  "copyright": "©️",
  "couch_and_lamp": "🛋️",
  "counterclockwise_arrows_button": "🔄",
  "couple_with_heart": "💑",
  "couple_with_heart_man_man": "👨‍❤️‍👨",
  "couple_with_heart_woman_man": "👩‍❤️‍👨",
  "couple_with_heart_woman_woman": "👩‍❤️‍👩",
  "cow": "🐄",
  "cow_face": "🐮",
  "cowboy_hat_face": "🤠",
  "crab": "🦀",
  "crayon": "🖍️",
  "credit_card": "💳",
  "crescent_moon": "🌙",
  "cricket": "🦗",
  "cricket_game": "🏏",
  "crocodile": "🐊",
  "croissant": "🥐",
  "cross_mark": "❌",
  "cross_mark_button": "❎",
  "crossed_fingers": "🤞",
  "crossed_flags": "🎌",
  "crossed_swords": "⚔️",
  "crown": "👑",
  "crying_cat": "😿",
  "crying_face": "😢",
  "crystal_ball": "🔮",
  "cucumber": "🥒",
  "cup_with_straw": "🥤",
  "cupcake": "🧁",
  "curling_stone": "🥌",
  "curly_loop": "➰",
  "currency_exchange": "💱",
  "curry_rice": "🍛",
  "custard": "🍮",
  "customs": "🛃",
  "cut_of_meat": "🥩",
  "cyclone": "🌀",
  "dagger": "🗡️",
  "dango": "🍡",
  "dashing_away": "💨",
  "deaf_man": "🧏‍♂️",
  "deaf_person": "🧏",
  "deaf_woman": "🧏‍♀️",
  "deciduous_tree": "🌳",
  "deer": "🦌",
  "delivery_truck": "🚚",
  "department_store": "🏬",
  "derelict_house": "🏚️",
  "desert": "🏜️",
  "desert_island": "🏝️",
  "desktop_computer": "🖥️",
  "detective": "🕵️",
  "diamond_suit": "♦️",
  "diamond_with_a_dot": "💠",
  "dim_button": "🔅",
  "direct_hit": "🎯",
  "disappointed_face": "😞",
  "diving_mask": "🤿",
  "division_sign": "➗",
  "diya_lamp": "🪔",
  "dizzy": "💫",
  "dizzy_face": "😵",
  "dna": "🧬",
  "dog": "🐕",
  "dog_face": "🐶",
  "dollar_banknote": "💵",
  "dolphin": "🐬",
  "door": "🚪",
  "dotted_six_pointed_star": "🔯",
  "double_curly_loop": "➿",
  "double_exclamation_mark": "‼️",
  "doughnut": "🍩",
  "dove": "🕊️",
  "down_arrow": "⬇️",
  "down_left_arrow": "↙️",
  "down_right_arrow": "↘️",
  "downcast_face_with_sweat": "😓",
  "downwards_button": "🔽",
  "dragon": "🐉",
  "dragon_face": "🐲",
  "dress": "👗",
  "drooling_face": "🤤",
  "drop_of_blood": "🩸",
  "droplet": "💧",
  "drum": "🥁",
  "duck": "🦆",
  "dumpling": "🥟",
  "dvd": "📀",
  "e_mail": "📧",
  "eagle": "🦅",
  "ear": "👂",
  "ear_of_corn": "🌽",
  "ear_with_hearing_aid": "🦻",
  "egg": "🥚",
  "eggplant": "🍆",
  "eight_o_clock": "🕗",
  "eight_pointed_star": "✴️",
  "eight_spoked_asterisk": "✳️",
  "eight_thirty": "🕣",
  "eject_button": "⏏️",
  "electric_plug": "🔌",
  "elephant": "🐘",
  "eleven_o_clock": "🕚",
  "eleven_thirty": "🕦",
  "elf": "🧝",
  "end_arrow": "🔚",
  "envelope": "✉️",
  "envelope_with_arrow": "📩",
  "euro_banknote": "💶",
  "evergreen_tree": "🌲",
  "ewe": "🐑",
  "exclamation_mark": "❗",
  "exclamation_question_mark": "⁉️",
  "exploding_head": "🤯",
  "expressionless_face": "😑",
  "eye": "👁️",
  "eye_in_speech_bubble": "👁️‍🗨️",
  "eyes": "👀",
  "face_blowing_a_kiss": "😘",
  "face_savoring_food": "😋",
  "face_screaming_in_fear": "😱",
  "face_vomiting": "🤮",
  "face_with_hand_over_mouth": "🤭",
  "face_with_head_bandage": "🤕",
  "face_with_medical_mask": "😷",
  "face_with_monocle": "🧐",
  "face_with_open_mouth": "😮",
  "face_with_raised_eyebrow": "🤨",
  "face_with_rolling_eyes": "🙄",
  "face_with_steam_from_nose": "😤",
  "face_with_symbols_on_mouth": "🤬",
  "face_with_tears_of_joy": "😂",
  "face_with_thermometer": "🤒",
  "face_with_tongue": "😛",
  "face_without_mouth": "😶",
  "factory": "🏭",
  "factory_worker": "🧑‍🏭",
  "fairy": "🧚",
  "falafel": "🧆",
  "fallen_leaf": "🍂",
  "family": "👪",
  "family_man_boy": "👨‍👦",
  "family_man_boy_boy": "👨‍👦‍👦",
  "family_man_girl": "👨‍👧",
  "family_man_girl_boy": "👨‍👧‍👦",
  "family_man_girl_girl": "👨‍👧‍👧",
  "family_man_man_boy": "👨‍👨‍👦",
  "family_man_man_boy_boy": "👨‍👨‍👦‍👦",
  "family_man_man_girl": "👨‍👨‍👧",
  "family_man_man_girl_boy": "👨‍👨‍👧‍👦",
  "family_man_man_girl_girl": "👨‍👨‍👧‍👧",
  "family_man_woman_boy": "👨‍👩‍👦",
  "family_man_woman_boy_boy": "👨‍👩‍👦‍👦",
  "family_man_woman_girl": "👨‍👩‍👧",
  "family_man_woman_girl_boy": "👨‍👩‍👧‍👦",
  "family_man_woman_girl_girl": "👨‍👩‍👧‍👧",
  "family_woman_boy": "👩‍👦",
  "family_woman_boy_boy": "👩‍👦‍👦",
  "family_woman_girl": "👩‍👧",
  "family_woman_girl_boy": "👩‍👧‍👦",
  "family_woman_girl_girl": "👩‍👧‍👧",
  "family_woman_woman_boy": "👩‍👩‍👦",
  "family_woman_woman_boy_boy": "👩‍👩‍👦‍👦",
  "family_woman_woman_girl": "👩‍👩‍👧",
  "family_woman_woman_girl_boy": "👩‍👩‍👧‍👦",
  "family_woman_woman_girl_girl": "👩‍👩‍👧‍👧",
  "farmer": "🧑‍🌾",
  "fast_down_button": "⏬",
  "fast_forward_button": "⏩",
  "fast_reverse_button": "⏪",
  "fast_up_button": "⏫",
  "fax_machine": "📠",
  "fearful_face": "😨",
  "female_sign": "♀️",
  "ferris_wheel": "🎡",
  "ferry": "⛴️",
  "field_hockey": "🏑",
  "file_cabinet": "🗄️",
  "file_folder": "📁",
  "film_frames": "🎞️",
  "film_projector": "📽️",
  "fire": "🔥",
  "fire_engine": "🚒",
  "fire_extinguisher": "🧯",
  "firecracker": "🧨",
  "firefighter": "🧑‍🚒",
  "fireworks": "🎆",
  "first_quarter_moon": "🌓",
  "first_quarter_moon_face": "🌛",
  "fish": "🐟",
  "fish_cake_with_swirl": "🍥",
  "fishing_pole": "🎣",
  "five_o_clock": "🕔",
  "five_thirty": "🕠",
  "flag_afghanistan": "🇦🇫",
  "flag_albania": "🇦🇱",
  "flag_algeria": "🇩🇿",
  "flag_american_samoa": "🇦🇸",
  "flag_andorra": "🇦🇩",
  "flag_angola": "🇦🇴",
  "flag_anguilla": "🇦🇮",
  "flag_antarctica": "🇦🇶",
  "flag_antigua_barbuda": "🇦🇬",
  "flag_argentina": "🇦🇷",
  "flag_armenia": "🇦🇲",
  "flag_aruba": "🇦🇼",
  "flag_ascension_island": "🇦🇨",
  "flag_australia": "🇦🇺",
  "flag_austria": "🇦🇹",
  "flag_azerbaijan": "🇦🇿",
  "flag_bahamas": "🇧🇸",
  "flag_bahrain": "🇧🇭",
  "flag_bangladesh": "🇧🇩",
  "flag_barbados": "🇧🇧",
  "flag_belarus": "🇧🇾",
  "flag_belgium": "🇧🇪",
  "flag_belize": "🇧🇿",
  "flag_benin": "🇧🇯",
  "flag_bermuda": "🇧🇲",
  "flag_bhutan": "🇧🇹",
  "flag_bolivia": "🇧🇴",
  "flag_bosnia_herzegovina": "🇧🇦",
  "flag_botswana": "🇧🇼",
  "flag_bouvet_island": "🇧🇻",
  "flag_brazil": "🇧🇷",
  "flag_british_indian_ocean_territory": "🇮🇴",
  "flag_british_virgin_islands": "🇻🇬",
  "flag_brunei": "🇧🇳",
  "flag_bulgaria": "🇧🇬",
  "flag_burkina_faso": "🇧🇫",
  "flag_burundi": "🇧🇮",
  "flag_c_te_d_ivoire": "🇨🇮",
  "flag_cambodia": "🇰🇭",
  "flag_cameroon": "🇨🇲",
  "flag_canada": "🇨🇦",
  "flag_canary_islands": "🇮🇨",
  "flag_cape_verde": "🇨🇻",
  "flag_caribbean_netherlands": "🇧🇶",
  "flag_cayman_islands": "🇰🇾",
  "flag_central_african_republic": "🇨🇫",
  "flag_ceuta_melilla": "🇪🇦",
  "flag_chad": "🇹🇩",
  "flag_chile": "🇨🇱",
  "flag_china": "🇨🇳",
  "flag_christmas_island": "🇨🇽",
  "flag_clipperton_island": "🇨🇵",
  "flag_cocos_islands": "🇨🇨",
  "flag_colombia": "🇨🇴",
  "flag_comoros": "🇰🇲",
  "flag_congo_brazzaville": "🇨🇬",
  "flag_congo_kinshasa": "🇨🇩",
  "flag_cook_islands": "🇨🇰",
  "flag_costa_rica": "🇨🇷",
  "flag_croatia": "🇭🇷",
  "flag_cuba": "🇨🇺",
  "flag_cura_ao": "🇨🇼",
  "flag_cyprus": "🇨🇾",
  "flag_czechia": "🇨🇿",
  "flag_denmark": "🇩🇰",
  "flag_diego_garcia": "🇩🇬",
  "flag_djibouti": "🇩🇯",
  "flag_dominica": "🇩🇲",
  "flag_dominican_republic": "🇩🇴",
  "flag_ecuador": "🇪🇨",
  "flag_egypt": "🇪🇬",
  "flag_el_salvador": "🇸🇻",
  "flag_england": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
  "flag_equatorial_guinea": "🇬🇶",
  "flag_eritrea": "🇪🇷",
  "flag_estonia": "🇪🇪",
  "flag_eswatini": "🇸🇿",
  "flag_ethiopia": "🇪🇹",
  "flag_european_union": "🇪🇺",
  "flag_falkland_islands": "🇫🇰",
  "flag_faroe_islands": "🇫🇴",
  "flag_fiji": "🇫🇯",
  "flag_finland": "🇫🇮",
  "flag_france": "🇫🇷",
  "flag_french_guiana": "🇬🇫",
  "flag_french_polynesia": "🇵🇫",
  "flag_french_southern_territories": "🇹🇫",
  "flag_gabon": "🇬🇦",
  "flag_gambia": "🇬🇲",
  "flag_georgia": "🇬🇪",
  "flag_germany": "🇩🇪",
  "flag_ghana": "🇬🇭",
  "flag_gibraltar": "🇬🇮",
  "flag_greece": "🇬🇷",
  "flag_greenland": "🇬🇱",
  "flag_grenada": "🇬🇩",
  "flag_guadeloupe": "🇬🇵",
  "flag_guam": "🇬🇺",
  "flag_guatemala": "🇬🇹",
  "flag_guernsey": "🇬🇬",
  "flag_guinea": "🇬🇳",
  "flag_guinea_bissau": "🇬🇼",
  "flag_guyana": "🇬🇾",
  "flag_haiti": "🇭🇹",
  "flag_heard_mcdonald_islands": "🇭🇲",
  "flag_honduras": "🇭🇳",
  "flag_hong_kong_sar_china": "🇭🇰",
  "flag_hungary": "🇭🇺",
  "flag_iceland": "🇮🇸",
  "flag_in_hole": "⛳",
  "flag_india": "🇮🇳",
  "flag_indonesia": "🇮🇩",
  "flag_iran": "🇮🇷",
  "flag_iraq": "🇮🇶",
  "flag_ireland": "🇮🇪",
  "flag_isle_of_man": "🇮🇲",
  "flag_israel": "🇮🇱",
  "flag_italy": "🇮🇹",
  "flag_jamaica": "🇯🇲",
  "flag_japan": "🇯🇵",
  "flag_jersey": "🇯🇪",
  "flag_jordan": "🇯🇴",
  "flag_kazakhstan": "🇰🇿",
  "flag_kenya": "🇰🇪",
  "flag_kiribati": "🇰🇮",
  "flag_kosovo": "🇽🇰",
  "flag_kuwait": "🇰🇼",
  "flag_kyrgyzstan": "🇰🇬",
  "flag_land_islands": "🇦🇽",
  "flag_laos": "🇱🇦",
  "flag_latvia": "🇱🇻",
  "flag_lebanon": "🇱🇧",
  "flag_lesotho": "🇱🇸",
  "flag_liberia": "🇱🇷",
  "flag_libya": "🇱🇾",
  "flag_liechtenstein": "🇱🇮",
  "flag_lithuania": "🇱🇹",
  "flag_luxembourg": "🇱🇺",
  "flag_macao_sar_china": "🇲🇴",
  "flag_madagascar": "🇲🇬",
  "flag_malawi": "🇲🇼",
  "flag_malaysia": "🇲🇾",
  "flag_maldives": "🇲🇻",
  "flag_mali": "🇲🇱",
  "flag_malta": "🇲🇹",
  "flag_marshall_islands": "🇲🇭",
  "flag_martinique": "🇲🇶",
  "flag_mauritania": "🇲🇷",
  "flag_mauritius": "🇲🇺",
  "flag_mayotte": "🇾🇹",
  "flag_mexico": "🇲🇽",
  "flag_micronesia": "🇫🇲",
  "flag_moldova": "🇲🇩",
  "flag_monaco": "🇲🇨",
  "flag_mongolia": "🇲🇳",
  "flag_montenegro": "🇲🇪",
  "flag_montserrat": "🇲🇸",
  "flag_morocco": "🇲🇦",
  "flag_mozambique": "🇲🇿",
  "flag_myanmar": "🇲🇲",
  "flag_namibia": "🇳🇦",
  "flag_nauru": "🇳🇷",
  "flag_nepal": "🇳🇵",
  "flag_netherlands": "🇳🇱",
  "flag_new_caledonia": "🇳🇨",
  "flag_new_zealand": "🇳🇿",
  "flag_nicaragua": "🇳🇮",
  "flag_niger": "🇳🇪",
  "flag_nigeria": "🇳🇬",
  "flag_niue": "🇳🇺",
  "flag_norfolk_island": "🇳🇫",
  "flag_north_korea": "🇰🇵",
  "flag_north_macedonia": "🇲🇰",
  "flag_northern_mariana_islands": "🇲🇵",
  "flag_norway": "🇳🇴",
  "flag_oman": "🇴🇲",
  "flag_pakistan": "🇵🇰",
  "flag_palau": "🇵🇼",
  "flag_palestinian_territories": "🇵🇸",
  "flag_panama": "🇵🇦",
  "flag_papua_new_guinea": "🇵🇬",
  "flag_paraguay": "🇵🇾",
  "flag_peru": "🇵🇪",
  "flag_philippines": "🇵🇭",
  "flag_pitcairn_islands": "🇵🇳",
  "flag_poland": "🇵🇱",
  "flag_portugal": "🇵🇹",
  "flag_puerto_rico": "🇵🇷",
  "flag_qatar": "🇶🇦",
  "flag_r_union": "🇷🇪",
  "flag_romania": "🇷🇴",
  "flag_russia": "🇷🇺",
  "flag_rwanda": "🇷🇼",
  "flag_s_o_tom_pr_ncipe": "🇸🇹",
  "flag_samoa": "🇼🇸",
  "flag_san_marino": "🇸🇲",
  "flag_saudi_arabia": "🇸🇦",
  "flag_scotland": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
  "flag_senegal": "🇸🇳",
  "flag_serbia": "🇷🇸",
  "flag_seychelles": "🇸🇨",
  "flag_sierra_leone": "🇸🇱",
  "flag_singapore": "🇸🇬",
  "flag_sint_maarten": "🇸🇽",
  "flag_slovakia": "🇸🇰",
  "flag_slovenia": "🇸🇮",
  "flag_solomon_islands": "🇸🇧",
  "flag_somalia": "🇸🇴",
  "flag_south_africa": "🇿🇦",
  "flag_south_georgia_south_sandwich_islands": "🇬🇸",
  "flag_south_korea": "🇰🇷",
  "flag_south_sudan": "🇸🇸",
  "flag_spain": "🇪🇸",
  "flag_sri_lanka": "🇱🇰",
  "flag_st_barth_lemy": "🇧🇱",
  "flag_st_helena": "🇸🇭",
  "flag_st_kitts_nevis": "🇰🇳",
  "flag_st_lucia": "🇱🇨",
  "flag_st_martin": "🇲🇫",
  "flag_st_pierre_miquelon": "🇵🇲",
  "flag_st_vincent_grenadines": "🇻🇨",
  "flag_sudan": "🇸🇩",
  "flag_suriname": "🇸🇷",
  "flag_svalbard_jan_mayen": "🇸🇯",
  "flag_sweden": "🇸🇪",
  "flag_switzerland": "🇨🇭",
  "flag_syria": "🇸🇾",
  "flag_taiwan": "🇹🇼",
  "flag_tajikistan": "🇹🇯",
  "flag_tanzania": "🇹🇿",
  "flag_thailand": "🇹🇭",
  "flag_timor_leste": "🇹🇱",
  "flag_togo": "🇹🇬",
  "flag_tokelau": "🇹🇰",
  "flag_tonga": "🇹🇴",
  "flag_trinidad_tobago": "🇹🇹",
  "flag_tristan_da_cunha": "🇹🇦",
  "flag_tunisia": "🇹🇳",
  "flag_turkey": "🇹🇷",
  "flag_turkmenistan": "🇹🇲",
  "flag_turks_caicos_islands": "🇹🇨",
  "flag_tuvalu": "🇹🇻",
  "flag_u_s_outlying_islands": "🇺🇲",
  "flag_u_s_virgin_islands": "🇻🇮",
  "flag_uganda": "🇺🇬",
  "flag_ukraine": "🇺🇦",
  "flag_united_arab_emirates": "🇦🇪",
  "flag_united_kingdom": "🇬🇧",
  "flag_united_nations": "🇺🇳",
  "flag_united_states": "🇺🇸",
  "flag_uruguay": "🇺🇾",
  "flag_uzbekistan": "🇺🇿",
  "flag_vanuatu": "🇻🇺",
  "flag_vatican_city": "🇻🇦",
  "flag_venezuela": "🇻🇪",
  "flag_vietnam": "🇻🇳",
  "flag_wales": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
  "flag_wallis_futuna": "🇼🇫",
  "flag_western_sahara": "🇪🇭",
  "flag_yemen": "🇾🇪",
  "flag_zambia": "🇿🇲",
  "flag_zimbabwe": "🇿🇼",
  "flamingo": "🦩",
  "flashlight": "🔦",
  "flat_shoe": "🥿",
  "fleur_de_lis": "⚜️",
  "flexed_biceps": "💪",
  "floppy_disk": "💾",
  "flower_playing_cards": "🎴",
  "flushed_face": "😳",
  "flying_disc": "🥏",
  "flying_saucer": "🛸",
  "fog": "🌫️",
  "foggy": "🌁",
  "folded_hands": "🙏",
  "foot": "🦶",
  "footprints": "👣",
  "fork_and_knife": "🍴",
  "fork_and_knife_with_plate": "🍽️",
  "fortune_cookie": "🥠",
  "fountain": "⛲",
  "fountain_pen": "🖋️",
  "four_leaf_clover": "🍀",
  "four_o_clock": "🕓",
  "four_thirty": "🕟",
  "fox": "🦊",
  "framed_picture": "🖼️",
  "free_button": "🆓",
  "french_fries": "🍟",
  "fried_shrimp": "🍤",
  "frog": "🐸",
  "front_facing_baby_chick": "🐥",
  "frowning_face": "☹️",
  "frowning_face_with_open_mouth": "😦",
  "fuel_pump": "⛽",
  "full_moon": "🌕",
  "full_moon_face": "🌝",
  "funeral_urn": "⚱️",
  "game_die": "🎲",
  "garlic": "🧄",
  "gear": "⚙️",
  "gem_stone": "💎",
  "gemini": "♊",
  "genie": "🧞",
  "ghost": "👻",
  "giraffe": "🦒",
  "girl": "👧",
  "glass_of_milk": "🥛",
  "glasses": "👓",
  "globe_showing_americas": "🌎",
  "globe_showing_asia_australia": "🌏",
  "globe_showing_europe_africa": "🌍",
  "globe_with_meridians": "🌐",
  "gloves": "🧤",
  "glowing_star": "🌟",
  "goal_net": "🥅",
  "goat": "🐐",
  "goblin": "👺",
  "goggles": "🥽",
  "gorilla": "🦍",
  "graduation_cap": "🎓",
  "grapes": "🍇",
  "green_apple": "🍏",
  "green_book": "📗",
  "green_circle": "🟢",
  "green_heart": "💚",
  "green_salad": "🥗",
  "green_square": "🟩",
  "grimacing_face": "😬",
  "grinning_cat": "😺",
  "grinning_cat_with_smiling_eyes": "😸",
  "grinning_face": "😀",
  "grinning_face_with_big_eyes": "😃",
  "grinning_face_with_smiling_eyes": "😄",
  "grinning_face_with_sweat": "😅",
  "grinning_squinting_face": "😆",
  "growing_heart": "💗",
  "guard": "💂",
  "guide_dog": "🦮",
  "guitar": "🎸",
  "hamburger": "🍔",
  "hammer": "🔨",
  "hammer_and_pick": "⚒️",
  "hammer_and_wrench": "🛠️",
  "hamster": "🐹",
  "hand_with_fingers_splayed": "🖐️",
  "handbag": "👜",
  "handshake": "🤝",
  "hatching_chick": "🐣",
  "headphone": "🎧",
  "health_worker": "🧑‍⚕️",
  "hear_no_evil_monkey": "🙉",
  "heart_decoration": "💟",
  "heart_exclamation": "❣️",
  "heart_suit": "♥️",
  "heart_with_arrow": "💘",
  "heart_with_ribbon": "💝",
  "heavy_dollar_sign": "💲",
  "hedgehog": "🦔",
  "helicopter": "🚁",
  "herb": "🌿",
  "hibiscus": "🌺",
  "high_heeled_shoe": "👠",
  "high_speed_train": "🚄",
  "high_voltage": "⚡",
  "hiking_boot": "🥾",
  "hindu_temple": "🛕",
  "hippopotamus": "🦛",
  "hole": "🕳️",
  "hollow_red_circle": "⭕",
  "honey_pot": "🍯",
  "honeybee": "🐝",
  "horizontal_traffic_light": "🚥",
  "horse": "🐎",
  "horse_face": "🐴",
  "horse_racing": "🏇",
  "hospital": "🏥",
  "hot_beverage": "☕",
  "hot_dog": "🌭",
  "hot_face": "🥵",
  "hot_pepper": "🌶️",
  "hot_springs": "♨️",
  "hotel": "🏨",
  "hourglass_done": "⌛",
  "hourglass_not_done": "⏳",
  "house": "🏠",
  "house_with_garden": "🏡",
  "houses": "🏘️",
  "hugging_face": "🤗",
  "hundred_points": "💯",
  "hushed_face": "😯",
  "ice": "🧊",
  "ice_cream": "🍨",
  "ice_hockey": "🏒",
  "ice_skate": "⛸️",
  "id_button": "🆔",
  "inbox_tray": "📥",
  "incoming_envelope": "📨",
  "index_pointing_up": "☝️",
  "infinity": "♾️",
  "information": "ℹ️",
  "input_latin_letters": "🔤",
  "input_latin_lowercase": "🔡",
  "input_latin_uppercase": "🔠",
  "input_numbers": "🔢",
  "input_symbols": "🔣",
  "jack_o_lantern": "🎃",
  "japanese_acceptable_button": "🉑",
  "japanese_application_button": "🈸",
  "japanese_bargain_button": "🉐",
  "japanese_castle": "🏯",
  "japanese_congratulations_button": "㊗️",
  "japanese_discount_button": "🈹",
  "japanese_dolls": "🎎",
  "japanese_free_of_charge_button": "🈚",
  "japanese_here_button": "🈁",
  "japanese_monthly_amount_button": "🈷️",
  "japanese_no_vacancy_button": "🈵",
  "japanese_not_free_of_charge_button": "🈶",
  "japanese_open_for_business_button": "🈺",
  "japanese_passing_grade_button": "🈴",
  "japanese_post_office": "🏣",
  "japanese_prohibited_button": "🈲",
  "japanese_reserved_button": "🈯",
  "japanese_secret_button": "㊙️",
  "japanese_service_charge_button": "🈂️",
  "japanese_symbol_for_beginner": "🔰",
  "japanese_vacancy_button": "🈳",
  "jeans": "👖",
  "joker": "🃏",
  "joystick": "🕹️",
  "judge": "🧑‍⚖️",
  "kaaba": "🕋",
  "kangaroo": "🦘",
  "key": "🔑",
  "keyboard": "⌨️",
  "keycap_": "*️⃣",
  "keycap_0": "0️⃣",
  "keycap_1": "1️⃣",
  "keycap_10": "🔟",
  "keycap_2": "2️⃣",
  "keycap_3": "3️⃣",
  "keycap_4": "4️⃣",
  "keycap_5": "5️⃣",
  "keycap_6": "6️⃣",
  "keycap_7": "7️⃣",
  "keycap_8": "8️⃣",
  "keycap_9": "9️⃣",
  "kick_scooter": "🛴",
  "kimono": "👘",
  "kiss": "💏",
  "kiss_man_man": "👨‍❤️‍💋‍👨",
  "kiss_mark": "💋",
  "kiss_woman_man": "👩‍❤️‍💋‍👨",
  "kiss_woman_woman": "👩‍❤️‍💋‍👩",
  "kissing_cat": "😽",
  "kissing_face": "😗",
  "kissing_face_with_closed_eyes": "😚",
  "kissing_face_with_smiling_eyes": "😙",
  "kitchen_knife": "🔪",
  "kite": "🪁",
  "kiwi_fruit": "🥝",
  "koala": "🐨",
  "lab_coat": "🥼",
  "label": "🏷️",
  "lacrosse": "🥍",
  "lady_beetle": "🐞",
  "laptop": "💻",
  "large_blue_diamond": "🔷",
  "large_orange_diamond": "🔶",
  "last_quarter_moon": "🌗",
  "last_quarter_moon_face": "🌜",
  "last_track_button": "⏮️",
  "latin_cross": "✝️",
  "leaf_fluttering_in_wind": "🍃",
  "leafy_green": "🥬",
  "ledger": "📒",
  "left_arrow": "⬅️",
  "left_arrow_curving_right": "↪️",
  "left_facing_fist": "🤛",
  "left_luggage": "🛅",
  "left_right_arrow": "↔️",
  "left_speech_bubble": "🗨️",
  "leg": "🦵",
  "lemon": "🍋",
  "leo": "♌",
  "leopard": "🐆",
  "level_slider": "🎚️",
  "libra": "♎",
  "light_bulb": "💡",
  "light_rail": "🚈",
  "link": "🔗",
  "linked_paperclips": "🖇️",
  "lion": "🦁",
  "lipstick": "💄",
  "litter_in_bin_sign": "🚮",
  "lizard": "🦎",
  "llama": "🦙",
  "lobster": "🦞",
  "locked": "🔒",
  "locked_with_key": "🔐",
  "locked_with_pen": "🔏",
  "locomotive": "🚂",
  "lollipop": "🍭",
  "lotion_bottle": "🧴",
  "loudly_crying_face": "😭",
  "loudspeaker": "📢",
  "love_hotel": "🏩",
  "love_letter": "💌",
  "love_you_gesture": "🤟",
  "luggage": "🧳",
  "lying_face": "🤥",
  "mage": "🧙",
  "magnet": "🧲",
  "magnifying_glass_tilted_left": "🔍",
  "magnifying_glass_tilted_right": "🔎",
  "mahjong_red_dragon": "🀄",
  "male_sign": "♂️",
  "man": "👨",
  "man_artist": "👨‍🎨",
  "man_astronaut": "👨‍🚀",
  "man_bald": "👨‍🦲",
  "man_beard": "🧔",
  "man_biking": "🚴‍♂️",
  "man_blond_hair": "👱‍♂️",
  "man_bouncing_ball": "⛹️‍♂️",
  "man_bowing": "🙇‍♂️",
  "man_cartwheeling": "🤸‍♂️",
  "man_climbing": "🧗‍♂️",
  "man_construction_worker": "👷‍♂️",
  "man_cook": "👨‍🍳",
  "man_curly_hair": "👨‍🦱",
  "man_dancing": "🕺",
  "man_detective": "🕵️‍♂️",
  "man_elf": "🧝‍♂️",
  "man_facepalming": "🤦‍♂️",
  "man_factory_worker": "👨‍🏭",
  "man_fairy": "🧚‍♂️",
  "man_farmer": "👨‍🌾",
  "man_firefighter": "👨‍🚒",
  "man_frowning": "🙍‍♂️",
  "man_genie": "🧞‍♂️",
  "man_gesturing_no": "🙅‍♂️",
  "man_gesturing_ok": "🙆‍♂️",
  "man_getting_haircut": "💇‍♂️",
  "man_getting_massage": "💆‍♂️",
  "man_golfing": "🏌️‍♂️",
  "man_guard": "💂‍♂️",
  "man_health_worker": "👨‍⚕️",
  "man_in_lotus_position": "🧘‍♂️",
  "man_in_manual_wheelchair": "👨‍🦽",
  "man_in_motorized_wheelchair": "👨‍🦼",
  "man_in_steamy_room": "🧖‍♂️",
  "man_in_suit_levitating": "🕴️",
  "man_in_tuxedo": "🤵",
  "man_judge": "👨‍⚖️",
  "man_juggling": "🤹‍♂️",
  "man_kneeling": "🧎‍♂️",
  "man_lifting_weights": "🏋️‍♂️",
  "man_mage": "🧙‍♂️",
  "man_mechanic": "👨‍🔧",
  "man_mountain_biking": "🚵‍♂️",
  "man_office_worker": "👨‍💼",
  "man_pilot": "👨‍✈️",
  "man_playing_handball": "🤾‍♂️",
  "man_playing_water_polo": "🤽‍♂️",
  "man_police_officer": "👮‍♂️",
  "man_pouting": "🙎‍♂️",
  "man_raising_hand": "🙋‍♂️",
  "man_red_hair": "👨‍🦰",
  "man_rowing_boat": "🚣‍♂️",
  "man_running": "🏃‍♂️",
  "man_s_shoe": "👞",
  "man_scientist": "👨‍🔬",
  "man_shrugging": "🤷‍♂️",
  "man_singer": "👨‍🎤",
  "man_standing": "🧍‍♂️",
  "man_student": "👨‍🎓",
  "man_superhero": "🦸‍♂️",
  "man_supervillain": "🦹‍♂️",
  "man_surfing": "🏄‍♂️",
  "man_swimming": "🏊‍♂️",
  "man_teacher": "👨‍🏫",
  "man_technologist": "👨‍💻",
  "man_tipping_hand": "💁‍♂️",
  "man_vampire": "🧛‍♂️",
  "man_walking": "🚶‍♂️",
  "man_wearing_turban": "👳‍♂️",
  "man_white_hair": "👨‍🦳",
  "man_with_probing_cane": "👨‍🦯",
  "man_with_skullcap": "👲",
  "man_zombie": "🧟‍♂️",
  "mango": "🥭",
  "mantelpiece_clock": "🕰️",
  "manual_wheelchair": "🦽",
  "map_of_japan": "🗾",
  "maple_leaf": "🍁",
  "martial_arts_uniform": "🥋",
  "mate": "🧉",
  "meat_on_bone": "🍖",
  "mechanic": "🧑‍🔧",
  "mechanical_arm": "🦾",
  "mechanical_leg": "🦿",
  "medical_symbol": "⚕️",
  "megaphone": "📣",
  "melon": "🍈",
  "memo": "📝",
  "men_holding_hands": "👬",
  "men_s_room": "🚹",
  "men_with_bunny_ears": "👯‍♂️",
  "men_wrestling": "🤼‍♂️",
  "menorah": "🕎",
  "mermaid": "🧜‍♀️",
  "merman": "🧜‍♂️",
  "merperson": "🧜",
  "metro": "🚇",
  "microbe": "🦠",
  "microphone": "🎤",
  "microscope": "🔬",
  "middle_finger": "🖕",
  "military_medal": "🎖️",
  "milky_way": "🌌",
  "minibus": "🚐",
  "minus_sign": "➖",
  "moai": "🗿",
  "mobile_phone": "📱",
  "mobile_phone_off": "📴",
  "mobile_phone_with_arrow": "📲",
  "money_bag": "💰",
  "money_mouth_face": "🤑",
  "money_with_wings": "💸",
  "monkey": "🐒",
  "monkey_face": "🐵",
  "monorail": "🚝",
  "moon_cake": "🥮",
  "moon_viewing_ceremony": "🎑",
  "mosque": "🕌",
  "mosquito": "🦟",
  "motor_boat": "🛥️",
  "motor_scooter": "🛵",
  "motorcycle": "🏍️",
  "motorized_wheelchair": "🦼",
  "motorway": "🛣️",
  "mount_fuji": "🗻",
  "mountain": "⛰️",
  "mountain_cableway": "🚠",
  "mountain_railway": "🚞",
  "mouse": "🐁",
  "mouse_face": "🐭",
  "mouth": "👄",
  "movie_camera": "🎥",
  "mrs_claus": "🤶",
  "multiplication_sign": "✖️",
  "mushroom": "🍄",
  "musical_keyboard": "🎹",
  "musical_note": "🎵",
  "musical_notes": "🎶",
  "musical_score": "🎼",
  "muted_speaker": "🔇",
  "nail_polish": "💅",
  "name_badge": "📛",
  "national_park": "🏞️",
  "nauseated_face": "🤢",
  "nazar_amulet": "🧿",
  "necktie": "👔",
  "nerd_face": "🤓",
  "neutral_face": "😐",
  "new_button": "🆕",
  "new_moon": "🌑",
  "new_moon_face": "🌚",
  "newspaper": "📰",
  "next_track_button": "⏭️",
  "ng_button": "🆖",
  "night_with_stars": "🌃",
  "nine_o_clock": "🕘",
  "nine_thirty": "🕤",
  "no_bicycles": "🚳",
  "no_entry": "⛔",
  "no_littering": "🚯",
  "no_mobile_phones": "📵",
  "no_one_under_eighteen": "🔞",
  "no_pedestrians": "🚷",
  "no_smoking": "🚭",
  "non_potable_water": "🚱",
  "nose": "👃",
  "notebook": "📓",
  "notebook_with_decorative_cover": "📔",
  "nut_and_bolt": "🔩",
  "o_button": "🅾️",
  "octopus": "🐙",
  "oden": "🍢",
  "office_building": "🏢",
  "office_worker": "🧑‍💼",
  "ogre": "👹",
  "oil_drum": "🛢️",
  "ok_button": "🆗",
  "ok_hand": "👌",
  "old_key": "🗝️",
  "old_man": "👴",
  "old_woman": "👵",
  "older_person": "🧓",
  "om": "🕉️",
  "on_arrow": "🔛",
  "oncoming_automobile": "🚘",
  "oncoming_bus": "🚍",
  "oncoming_fist": "👊",
  "oncoming_police_car": "🚔",
  "oncoming_taxi": "🚖",
  "one_o_clock": "🕐",
  "one_piece_swimsuit": "🩱",
  "one_thirty": "🕜",
  "onion": "🧅",
  "open_book": "📖",
  "open_file_folder": "📂",
  "open_hands": "👐",
  "open_mailbox_with_lowered_flag": "📭",
  "open_mailbox_with_raised_flag": "📬",
  "ophiuchus": "⛎",
  "optical_disk": "💿",
  "orange_book": "📙",
  "orange_circle": "🟠",
  "orange_heart": "🧡",
  "orange_square": "🟧",
  "orangutan": "🦧",
  "orthodox_cross": "☦️",
  "otter": "🦦",
  "outbox_tray": "📤",
  "owl": "🦉",
  "ox": "🐂",
  "oyster": "🦪",
  "p_button": "🅿️",
  "package": "📦",
  "page_facing_up": "📄",
  "page_with_curl": "📃",
  "pager": "📟",
  "paintbrush": "🖌️",
  "palm_tree": "🌴",
  "palms_up_together": "🤲",
  "pancakes": "🥞",
  "panda": "🐼",
  "paperclip": "📎",
  "parachute": "🪂",
  "parrot": "🦜",
  "part_alternation_mark": "〽️",
  "party_popper": "🎉",
  "partying_face": "🥳",
  "passenger_ship": "🛳️",
  "passport_control": "🛂",
  "pause_button": "⏸️",
  "paw_prints": "🐾",
  "peace_symbol": "☮️",
  "peach": "🍑",
  "peacock": "🦚",
  "peanuts": "🥜",
  "pear": "🍐",
  "pen": "🖊️",
  "pencil": "✏️",
  "penguin": "🐧",
  "pensive_face": "😔",
  "people_holding_hands": "🧑‍🤝‍🧑",
  "people_with_bunny_ears": "👯",
  "people_wrestling": "🤼",
  "performing_arts": "🎭",
  "persevering_face": "😣",
  "person": "🧑",
  "person_bald": "🧑‍🦲",
  "person_biking": "🚴",
  "person_blond_hair": "👱",
  "person_bouncing_ball": "⛹️",
  "person_bowing": "🙇",
  "person_cartwheeling": "🤸",
  "person_climbing": "🧗",
  "person_curly_hair": "🧑‍🦱",
  "person_facepalming": "🤦",
  "person_fencing": "🤺",
  "person_frowning": "🙍",
  "person_gesturing_no": "🙅",
  "person_gesturing_ok": "🙆",
  "person_getting_haircut": "💇",
  "person_getting_massage": "💆",
  "person_golfing": "🏌️",
  "person_in_bed": "🛌",
  "person_in_lotus_position": "🧘",
  "person_in_manual_wheelchair": "🧑‍🦽",
  "person_in_motorized_wheelchair": "🧑‍🦼",
  "person_in_steamy_room": "🧖",
  "person_juggling": "🤹",
  "person_kneeling": "🧎",
  "person_lifting_weights": "🏋️",
  "person_mountain_biking": "🚵",
  "person_playing_handball": "🤾",
  "person_playing_water_polo": "🤽",
  "person_pouting": "🙎",
  "person_raising_hand": "🙋",
  "person_red_hair": "🧑‍🦰",
  "person_rowing_boat": "🚣",
  "person_running": "🏃",
  "person_shrugging": "🤷",
  "person_standing": "🧍",
  "person_surfing": "🏄",
  "person_swimming": "🏊",
  "person_taking_bath": "🛀",
  "person_tipping_hand": "💁",
  "person_walking": "🚶",
  "person_wearing_turban": "👳",
  "person_white_hair": "🧑‍🦳",
  "person_with_probing_cane": "🧑‍🦯",
  "petri_dish": "🧫",
  "pick": "⛏️",
  "pie": "🥧",
  "pig": "🐖",
  "pig_face": "🐷",
  "pig_nose": "🐽",
  "pile_of_poo": "💩",
  "pill": "💊",
  "pilot": "🧑‍✈️",
  "pinching_hand": "🤏",
  "pine_decoration": "🎍",
  "pineapple": "🍍",
  "ping_pong": "🏓",
  "pirate_flag": "🏴‍☠️",
  "pisces": "♓",
  "pistol": "🔫",
  "pizza": "🍕",
  "place_of_worship": "🛐",
  "play_button": "▶️",
  "play_or_pause_button": "⏯️",
  "pleading_face": "🥺",
  "plus_sign": "➕",
  "police_car": "🚓",
  "police_car_light": "🚨",
  "police_officer": "👮",
  "poodle": "🐩",
  "pool_8_ball": "🎱",
  "popcorn": "🍿",
  "post_office": "🏤",
  "postal_horn": "📯",
  "postbox": "📮",
  "pot_of_food": "🍲",
  "potable_water": "🚰",
  "potato": "🥔",
  "poultry_leg": "🍗",
  "pound_banknote": "💷",
  "pouting_cat": "😾",
  "pouting_face": "😡",
  "prayer_beads": "📿",
  "pregnant_woman": "🤰",
  "pretzel": "🥨",
  "prince": "🤴",
  "princess": "👸",
  "printer": "🖨️",
  "probing_cane": "🦯",
  "prohibited": "🚫",
  "purple_circle": "🟣",
  "purple_heart": "💜",
  "purple_square": "🟪",
  "purse": "👛",
  "pushpin": "📌",
  "puzzle_piece": "🧩",
  "question_mark": "❓",
  "rabbit": "🐇",
  "rabbit_face": "🐰",
  "raccoon": "🦝",
  "racing_car": "🏎️",
  "radio": "📻",
  "radio_button": "🔘",
  "radioactive": "☢️",
  "railway_car": "🚃",
  "railway_track": "🛤️",
  "rainbow": "🌈",
  "rainbow_flag": "🏳️‍🌈",
  "raised_back_of_hand": "🤚",
  "raised_fist": "✊",
  "raised_hand": "✋",
  "raising_hands": "🙌",
  "ram": "🐏",
  "rat": "🐀",
  "razor": "🪒",
  "receipt": "🧾",
  "record_button": "⏺️",
  "recycling_symbol": "♻️",
  "red_apple": "🍎",
  "red_circle": "🔴",
  "red_envelope": "🧧",
  "red_heart": "❤️",
  "red_paper_lantern": "🏮",
  "red_square": "🟥",
  "red_triangle_pointed_down": "🔻",
  "red_triangle_pointed_up": "🔺",
  "registered": "®️",
  "relieved_face": "😌",
  "reminder_ribbon": "🎗️",
  "repeat_button": "🔁",
  "repeat_single_button": "🔂",
  "rescue_worker_s_helmet": "⛑️",
  "restroom": "🚻",
  "reverse_button": "◀️",
  "revolving_hearts": "💞",
  "rhinoceros": "🦏",
  "ribbon": "🎀",
  "rice_ball": "🍙",
  "rice_cracker": "🍘",
  "right_anger_bubble": "🗯️",
  "right_arrow": "➡️",
  "right_arrow_curving_down": "⤵️",
  "right_arrow_curving_left": "↩️",
  "right_arrow_curving_up": "⤴️",
  "right_facing_fist": "🤜",
  "ring": "💍",
  "ringed_planet": "🪐",
  "roasted_sweet_potato": "🍠",
  "robot": "🤖",
  "rocket": "🚀",
  "roll_of_paper": "🧻",
  "rolled_up_newspaper": "🗞️",
  "roller_coaster": "🎢",
  "rolling_on_the_floor_laughing": "🤣",
  "rooster": "🐓",
  "rose": "🌹",
  "rosette": "🏵️",
  "round_pushpin": "📍",
  "rugby_football": "🏉",
  "running_shirt": "🎽",
  "running_shoe": "👟",
  "sad_but_relieved_face": "😥",
  "safety_pin": "🧷",
  "safety_vest": "🦺",
  "sagittarius": "♐",
  "sailboat": "⛵",
  "sake": "🍶",
  "salt": "🧂",
  "sandwich": "🥪",
  "santa_claus": "🎅",
  "sari": "🥻",
  "satellite": "🛰️",
  "satellite_antenna": "📡",
  "sauropod": "🦕",
  "saxophone": "🎷",
  "scarf": "🧣",
  "school": "🏫",
  "scientist": "🧑‍🔬",
  "scissors": "✂️",
  "scorpio": "♏",
  "scorpion": "🦂",
  "scroll": "📜",
  "seat": "💺",
  "see_no_evil_monkey": "🙈",
  "seedling": "🌱",
  "selfie": "🤳",
  "service_dog": "🐕‍🦺",
  "seven_o_clock": "🕖",
  "seven_thirty": "🕢",
  "shallow_pan_of_food": "🥘",
  "shamrock": "☘️",
  "shark": "🦈",
  "shaved_ice": "🍧",
  "sheaf_of_rice": "🌾",
  "shield": "🛡️",
  "shinto_shrine": "⛩️",
  "ship": "🚢",
  "shooting_star": "🌠",
  "shopping_bags": "🛍️",
  "shopping_cart": "🛒",
  "shortcake": "🍰",
  "shorts": "🩳",
  "shower": "🚿",
  "shrimp": "🦐",
  "shuffle_tracks_button": "🔀",
  "shushing_face": "🤫",
  "sign_of_the_horns": "🤘",
  "singer": "🧑‍🎤",
  "six_o_clock": "🕕",
  "six_thirty": "🕡",
  "skateboard": "🛹",
  "skier": "⛷️",
  "skis": "🎿",
  "skull": "💀",
  "skull_and_crossbones": "☠️",
  "skunk": "🦨",
  "sled": "🛷",
  "sleeping_face": "😴",
  "sleepy_face": "😪",
  "slightly_frowning_face": "🙁",
  "slightly_smiling_face": "🙂",
  "slot_machine": "🎰",
  "sloth": "🦥",
  "small_airplane": "🛩️",
  "small_blue_diamond": "🔹",
  "small_orange_diamond": "🔸",
  "smiling_cat_with_heart_eyes": "😻",
  "smiling_face": "☺️",
  "smiling_face_with_halo": "😇",
  "smiling_face_with_heart_eyes": "😍",
  "smiling_face_with_hearts": "🥰",
  "smiling_face_with_horns": "😈",
  "smiling_face_with_smiling_eyes": "😊",
  "smiling_face_with_sunglasses": "😎",
  "smirking_face": "😏",
  "snail": "🐌",
  "snake": "🐍",
  "sneezing_face": "🤧",
  "snow_capped_mountain": "🏔️",
  "snowboarder": "🏂",
  "snowflake": "❄️",
  "snowman": "☃️",
  "snowman_without_snow": "⛄",
  "soap": "🧼",
  "soccer_ball": "⚽",
  "socks": "🧦",
  "soft_ice_cream": "🍦",
  "softball": "🥎",
  "soon_arrow": "🔜",
  "sos_button": "🆘",
  "spade_suit": "♠️",
  "spaghetti": "🍝",
  "sparkle": "❇️",
  "sparkler": "🎇",
  "sparkles": "✨",
  "sparkling_heart": "💖",
  "speak_no_evil_monkey": "🙊",
  "speaker_high_volume": "🔊",
  "speaker_low_volume": "🔈",
  "speaker_medium_volume": "🔉",
  "speaking_head": "🗣️",
  "speech_balloon": "💬",
  "speedboat": "🚤",
  "spider": "🕷️",
  "spider_web": "🕸️",
  "spiral_calendar": "🗓️",
  "spiral_notepad": "🗒️",
  "spiral_shell": "🐚",
  "sponge": "🧽",
  "spoon": "🥄",
  "sport_utility_vehicle": "🚙",
  "sports_medal": "🏅",
  "spouting_whale": "🐳",
  "squid": "🦑",
  "squinting_face_with_tongue": "😝",
  "stadium": "🏟️",
  "star": "⭐",
  "star_and_crescent": "☪️",
  "star_of_david": "✡️",
  "star_struck": "🤩",
  "station": "🚉",
  "statue_of_liberty": "🗽",
  "steaming_bowl": "🍜",
  "stethoscope": "🩺",
  "stop_button": "⏹️",
  "stop_sign": "🛑",
  "stopwatch": "⏱️",
  "straight_ruler": "📏",
  "strawberry": "🍓",
  "student": "🧑‍🎓",
  "studio_microphone": "🎙️",
  "stuffed_flatbread": "🥙",
  "sun": "☀️",
  "sun_behind_cloud": "⛅",
  "sun_behind_large_cloud": "🌥️",
  "sun_behind_rain_cloud": "🌦️",
  "sun_behind_small_cloud": "🌤️",
  "sun_with_face": "🌞",
  "sunflower": "🌻",
  "sunglasses": "🕶️",
  "sunrise": "🌅",
  "sunrise_over_mountains": "🌄",
  "sunset": "🌇",
  "superhero": "🦸",
  "supervillain": "🦹",
  "sushi": "🍣",
  "suspension_railway": "🚟",
  "swan": "🦢",
  "sweat_droplets": "💦",
  "synagogue": "🕍",
  "syringe": "💉",
  "t_rex": "🦖",
  "t_shirt": "👕",
  "taco": "🌮",
  "takeout_box": "🥡",
  "tanabata_tree": "🎋",
  "tangerine": "🍊",
  "taurus": "♉",
  "taxi": "🚕",
  "teacher": "🧑‍🏫",
  "teacup_without_handle": "🍵",
  "tear_off_calendar": "📆",
  "technologist": "🧑‍💻",
  "teddy_bear": "🧸",
  "telephone": "☎️",
  "telephone_receiver": "📞",
  "telescope": "🔭",
  "television": "📺",
  "ten_o_clock": "🕙",
  "ten_thirty": "🕥",
  "tennis": "🎾",
  "tent": "⛺",
  "test_tube": "🧪",
  "thermometer": "🌡️",
  "thinking_face": "🤔",
  "thought_balloon": "💭",
  "thread": "🧵",
  "three_o_clock": "🕒",
  "three_thirty": "🕞",
  "thumbs_down": "👎",
  "thumbs_up": "👍",
  "ticket": "🎫",
  "tiger": "🐅",
  "tiger_face": "🐯",
  "timer_clock": "⏲️",
  "tired_face": "😫",
  "toilet": "🚽",
  "tokyo_tower": "🗼",
  "tomato": "🍅",
  "tongue": "👅",
  "toolbox": "🧰",
  "tooth": "🦷",
  "top_arrow": "🔝",
  "top_hat": "🎩",
  "tornado": "🌪️",
  "trackball": "🖲️",
  "tractor": "🚜",
  "trade_mark": "™️",
  "train": "🚆",
  "tram": "🚊",
  "tram_car": "🚋",
  "triangular_flag": "🚩",
  "triangular_ruler": "📐",
  "trident_emblem": "🔱",
  "trolleybus": "🚎",
  "trophy": "🏆",
  "tropical_drink": "🍹",
  "tropical_fish": "🐠",
  "trumpet": "🎺",
  "tulip": "🌷",
  "tumbler_glass": "🥃",
  "turkey": "🦃",
  "turtle": "🐢",
  "twelve_o_clock": "🕛",
  "twelve_thirty": "🕧",
  "two_hearts": "💕",
  "two_hump_camel": "🐫",
  "two_o_clock": "🕑",
  "two_thirty": "🕝",
  "umbrella": "☂️",
  "umbrella_on_ground": "⛱️",
  "umbrella_with_rain_drops": "☔",
  "unamused_face": "😒",
  "unicorn": "🦄",
  "unlocked": "🔓",
  "up_arrow": "⬆️",
  "up_button": "🆙",
  "up_down_arrow": "↕️",
  "up_left_arrow": "↖️",
  "up_right_arrow": "↗️",
  "upside_down_face": "🙃",
  "upwards_button": "🔼",
  "vampire": "🧛",
  "vertical_traffic_light": "🚦",
  "vibration_mode": "📳",
  "victory_hand": "✌️",
  "video_camera": "📹",
  "video_game": "🎮",
  "videocassette": "📼",
  "violin": "🎻",
  "virgo": "♍",
  "volcano": "🌋",
  "volleyball": "🏐",
  "vs_button": "🆚",
  "vulcan_salute": "🖖",
  "waffle": "🧇",
  "waning_crescent_moon": "🌘",
  "waning_gibbous_moon": "🌖",
  "warning": "⚠️",
  "wastebasket": "🗑️",
  "watch": "⌚",
  "water_buffalo": "🐃",
  "water_closet": "🚾",
  "water_wave": "🌊",
  "watermelon": "🍉",
  "waving_hand": "👋",
  "wavy_dash": "〰️",
  "waxing_crescent_moon": "🌒",
  "waxing_gibbous_moon": "🌔",
  "weary_cat": "🙀",
  "weary_face": "😩",
  "wedding": "💒",
  "whale": "🐋",
  "wheel_of_dharma": "☸️",
  "wheelchair_symbol": "♿",
  "white_circle": "⚪",
  "white_exclamation_mark": "❕",
  "white_flag": "🏳️",
  "white_flower": "💮",
  "white_heart": "🤍",
  "white_large_square": "⬜",
  "white_medium_small_square": "◽",
  "white_medium_square": "◻️",
  "white_question_mark": "❔",
  "white_small_square": "▫️",
  "white_square_button": "🔳",
  "wilted_flower": "🥀",
  "wind_chime": "🎐",
  "wind_face": "🌬️",
  "wine_glass": "🍷",
  "winking_face": "😉",
  "winking_face_with_tongue": "😜",
  "wolf": "🐺",
  "woman": "👩",
  "woman_and_man_holding_hands": "👫",
  "woman_artist": "👩‍🎨",
  "woman_astronaut": "👩‍🚀",
  "woman_bald": "👩‍🦲",
  "woman_biking": "🚴‍♀️",
  "woman_blond_hair": "👱‍♀️",
  "woman_bouncing_ball": "⛹️‍♀️",
  "woman_bowing": "🙇‍♀️",
  "woman_cartwheeling": "🤸‍♀️",
  "woman_climbing": "🧗‍♀️",
  "woman_construction_worker": "👷‍♀️",
  "woman_cook": "👩‍🍳",
  "woman_curly_hair": "👩‍🦱",
  "woman_dancing": "💃",
  "woman_detective": "🕵️‍♀️",
  "woman_elf": "🧝‍♀️",
  "woman_facepalming": "🤦‍♀️",
  "woman_factory_worker": "👩‍🏭",
  "woman_fairy": "🧚‍♀️",
  "woman_farmer": "👩‍🌾",
  "woman_firefighter": "👩‍🚒",
  "woman_frowning": "🙍‍♀️",
  "woman_genie": "🧞‍♀️",
  "woman_gesturing_no": "🙅‍♀️",
  "woman_gesturing_ok": "🙆‍♀️",
  "woman_getting_haircut": "💇‍♀️",
  "woman_getting_massage": "💆‍♀️",
  "woman_golfing": "🏌️‍♀️",
  "woman_guard": "💂‍♀️",
  "woman_health_worker": "👩‍⚕️",
  "woman_in_lotus_position": "🧘‍♀️",
  "woman_in_manual_wheelchair": "👩‍🦽",
  "woman_in_motorized_wheelchair": "👩‍🦼",
  "woman_in_steamy_room": "🧖‍♀️",
  "woman_judge": "👩‍⚖️",
  "woman_juggling": "🤹‍♀️",
  "woman_kneeling": "🧎‍♀️",
  "woman_lifting_weights": "🏋️‍♀️",
  "woman_mage": "🧙‍♀️",
  "woman_mechanic": "👩‍🔧",
  "woman_mountain_biking": "🚵‍♀️",
  "woman_office_worker": "👩‍💼",
  "woman_pilot": "👩‍✈️",
  "woman_playing_handball": "🤾‍♀️",
  "woman_playing_water_polo": "🤽‍♀️",
  "woman_police_officer": "👮‍♀️",
  "woman_pouting": "🙎‍♀️",
  "woman_raising_hand": "🙋‍♀️",
  "woman_red_hair": "👩‍🦰",
  "woman_rowing_boat": "🚣‍♀️",
  "woman_running": "🏃‍♀️",
  "woman_s_boot": "👢",
  "woman_s_clothes": "👚",
  "woman_s_hat": "👒",
  "woman_s_sandal": "👡",
  "woman_scientist": "👩‍🔬",
  "woman_shrugging": "🤷‍♀️",
  "woman_singer": "👩‍🎤",
  "woman_standing": "🧍‍♀️",
  "woman_student": "👩‍🎓",
  "woman_superhero": "🦸‍♀️",
  "woman_supervillain": "🦹‍♀️",
  "woman_surfing": "🏄‍♀️",
  "woman_swimming": "🏊‍♀️",
  "woman_teacher": "👩‍🏫",
  "woman_technologist": "👩‍💻",
  "woman_tipping_hand": "💁‍♀️",
  "woman_vampire": "🧛‍♀️",
  "woman_walking": "🚶‍♀️",
  "woman_wearing_turban": "👳‍♀️",
  "woman_white_hair": "👩‍🦳",
  "woman_with_headscarf": "🧕",
  "woman_with_probing_cane": "👩‍🦯",
  "woman_zombie": "🧟‍♀️",
  "women_holding_hands": "👭",
  "women_s_room": "🚺",
  "women_with_bunny_ears": "👯‍♀️",
  "women_wrestling": "🤼‍♀️",
  "woozy_face": "🥴",
  "world_map": "🗺️",
  "worried_face": "😟",
  "wrapped_gift": "🎁",
  "wrench": "🔧",
  "writing_hand": "✍️",
  "yarn": "🧶",
  "yawning_face": "🥱",
  "yellow_circle": "🟡",
  "yellow_heart": "💛",
  "yellow_square": "🟨",
  "yen_banknote": "💴",
  "yin_yang": "☯️",
  "yo_yo": "🪀",
  "zany_face": "🤪",
  "zebra": "🦓",
  "zipper_mouth_face": "🤐",
  "zombie": "🧟",
  "zzz": "💤",
};

const emojisIndex = Object.fromEntries(Object.entries(emojis).map(([key, value]) => [value, key]));

const isEmoji = text => {
  if (!text) {
    return false;
  }
  text = text.trim();
  if (text.length === 0) {
    return false;
  }
  const match = text.match(emojiRegex);
  if (!match) {
    return false;
  }
  return match[0].length == text.length;
}

const findEmojis = text => text.match(emojiRegex) || [];

// Export everything needed
export {
  emojis,
  emojisIndex,
  isEmoji,
  findEmojis,
  emojiRegex
};